import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin-left":"325px"}},[_c(VImg,{staticStyle:{"width":"75%"},attrs:{"src":"/graph"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }